/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypeworddragconnect4Inputs */

const zh_learn_mistakestypeworddragconnect4 = /** @type {(inputs: Learn_Mistakestypeworddragconnect4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拖拽连线`)
};

const en_learn_mistakestypeworddragconnect4 = /** @type {(inputs: Learn_Mistakestypeworddragconnect4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word Drag Connect`)
};

const es_learn_mistakestypeworddragconnect4 = /** @type {(inputs: Learn_Mistakestypeworddragconnect4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrastrar y conectar`)
};

/**
* | output |
* | --- |
* | "Word Drag Connect" |
*
* @param {Learn_Mistakestypeworddragconnect4Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypeworddragconnect4 = /** @type {((inputs?: Learn_Mistakestypeworddragconnect4Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypeworddragconnect4Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypeworddragconnect4(inputs)
	if (locale === "en") return en_learn_mistakestypeworddragconnect4(inputs)
	return es_learn_mistakestypeworddragconnect4(inputs)
});
export { learn_mistakestypeworddragconnect4 as "learn_mistakesTypeWordDragConnect" }